import { httpRequest } from "@services/http";
import type { AdGroupListItem } from "@models/adGroup.model";

export class CommandListEngagementAdGroups {
  async run(engagementId: number): Promise<AdGroupListItem[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/ad-groups/`;
    return httpRequest<AdGroupListItem[]>(url, { method: "GET" });
  }
}
